import React from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import get from 'lodash/get';
import countriesService from '../services/countriesService';

const CountryName = ({ code, countriesFetch }) => (
  <>
    {get(
      find(countriesFetch && countriesFetch.value, { id: code.toLowerCase() }),
      'name',
      code.toUpperCase()
    )}
  </>
);

CountryName.propTypes = {
  code: PropTypes.string.isRequired,
  countriesFetch: PropTypes.object.isRequired,
};

CountryName.defaultProps = {};

export default countriesService(CountryName);
